import { render, staticRenderFns } from "./island.vue?vue&type=template&id=eedf82bc&"
import script from "./island.vue?vue&type=script&lang=js&"
export * from "./island.vue?vue&type=script&lang=js&"
import style0 from "./island.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports